/** 會員端語系 localStorage key（值為 language.lang_code） */
export const LOCALE_STORAGE_KEY = 'formosa_member_locale';

export const LOCALE_CHANGE_EVENT = 'formosa:locale-change';

export function getStoredLocale() {
  if (typeof window === 'undefined') {
    return '';
  }
  return localStorage.getItem(LOCALE_STORAGE_KEY) || '';
}

export function setStoredLocale(langCode) {
  if (typeof window === 'undefined') {
    return;
  }
  if (!langCode) {
    localStorage.removeItem(LOCALE_STORAGE_KEY);
  } else {
    localStorage.setItem(LOCALE_STORAGE_KEY, langCode);
  }
  window.dispatchEvent(new CustomEvent(LOCALE_CHANGE_EVENT, { detail: langCode || '' }));
}

/** 從 language 表資料解析目前選中語系（lang_code） */
export function resolveSelectedLocale(languages, storedLangCode) {
  if (!Array.isArray(languages) || languages.length === 0) {
    return storedLangCode || '';
  }
  const matched = languages.find((item) => item.langCode === storedLangCode);
  if (matched) {
    return matched.langCode;
  }
  return languages[0].langCode || '';
}
